import React, { useId } from 'react';
import '../../css/Booking/cancellationTermsAgreement.css';

export default function CancellationTermsAgreement({ checked, onChange, disabled = false, onViewTerms }) {
  const id = useId();
  return (
    <div className='cancellation-terms-agreement'>
      <label className='cancellation-terms-agreement-label' htmlFor={id}>
        <input
          id={id}
          type='checkbox'
          name='cancellation_terms_agreed'
          checked={checked === true}
          onChange={(event) => onChange(event.target.checked)}
          disabled={disabled}
          required
        />
        <span>취소료 규정에 동의합니다. <span className='cancellation-terms-required'>(필수)</span></span>
      </label>
      {onViewTerms && (
        <button className='cancellation-terms-view' type='button' onClick={onViewTerms} disabled={disabled}>
          취소료 규정 보기
        </button>
      )}
    </div>
  );
}
